import MazSpinner from "./_main.vue";

MazSpinner.install = (Vue) => {
  Vue.component(MazSpinner.name, MazSpinner);
};

export default MazSpinner;
